// ==========================================
// 1. CATEGORY HIERARCHY (UPDATED)
// ==========================================
export const categoryHierarchy = {
 "Seating": [
    "Office Chair", "Visitor Chair", "Mesh Office Chair",  "Lounge Chair", "Bar Stool"],

  "Table": [
    "Executive Table", "Reception Table", "Conference Table", "Center Table"],

  "Workstations": ["Workstation"], // Kept separate with no subcategories
  "Storage": [],
  "Sofa / Lounger": [ "Sofa"],
};

export const categories = ["All Products", ...Object.keys(categoryHierarchy)];

// ==========================================
// 2. PRODUCTS LIST 
// ==========================================
// ==========================================
export const products = [
  // ==========================================
  // --- SEATING (REAL CATALOG) ---
  // ==========================================
  { id: 1001, name: "Seltos Medium Back Grey", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/seltos_mb_grey.png"], featured: false, specifications: { backType: "Medium Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1002, name: "Beta Chair Grey High Back", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/beta_chair_grey_hb.png"], featured: false, specifications: { backType: "High Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1003, name: "Lumina Leather Electric Chair", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/ck553_leather_electric_chair.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1004, name: "Butter Fly Chair High Back Grey", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/butter_fly_chair_hb_grey.png"], featured: false, specifications: { backType: "High Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1005, name: "Net Border Chair High Back", category: "Seating", subcategory: "Mesh Office Chair", images: ["/images/chairs/net_border_chair_hb_imported.png"], featured: false, specifications: { backType: "High Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1006, name: "Seltos Chair Black Medium Back", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/seltos_chair_black_mb.png"], featured: false, specifications: { backType: "Medium Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1007, name: "Polyfill Premium Chair High Back Cream", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/polyfill_premium_chair_hb_cream.png"], featured: false, specifications: { backType: "High Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1008, name: "Aura Chair", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/a23_imported_chair.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1009, name: "Magnite High Back", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/magnite_hb.png"], featured: false, specifications: { backType: "High Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1010, name: "Beta Pro High Back Black", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/beta_pro_hb_black.png"], featured: false, specifications: { backType: "High Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1011, name: "Feedo Chair High Back", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/feedo_chair_hb.png"], featured: false, specifications: { backType: "High Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1012, name: "Aspire Chair", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/a618_imported_chair.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1013, name: "I Cherry Medium Back Black", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/i_cherry_mb_black.png"], featured: false, specifications: { backType: "Medium Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1014, name: "I Cherry Chair Black Medium Back", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/i_cherry_chair_black_mb.png"], featured: false, specifications: { backType: "Medium Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1015, name: "Bar Stool Blue", category: "Seating", subcategory: "Bar Stool", images: ["/images/chairs/bar_stool_blue.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1016, name: "Button Stool Revolving", category: "Seating", subcategory: "Bar Stool", images: ["/images/chairs/button_stool_revolving.jpg"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1017, name: "Crown Premium High Back Grey", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/crown_premium_hb_grey.png"], featured: false, specifications: { backType: "High Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1018, name: "Aero Net Revolving Medium Back Chair", category: "Seating", subcategory: "Mesh Office Chair", images: ["/images/chairs/aero_net_revolving_mb_chair.png"], featured: false, specifications: { backType: "Medium Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1019, name: "Polyfill Premium Chair Medium Back Cream", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/polyfill_premium_chair_mb_cream.png"], featured: false, specifications: { backType: "Medium Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1020, name: "Half Rib Chair High Back", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/half_rib_chair_hb.png"], featured: false, specifications: { backType: "High Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1021, name: "Flower Puffy Chair Green", category: "Seating", subcategory: "Lounge Chair", images: ["/images/chairs/flower_puffy_chair_green.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1022, name: "Nova Chair", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/6127a_chair.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1023, name: "Sierra Tan High Back Chair", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/6a81_tan_hb_chair.png"], featured: false, specifications: { backType: "High Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1024, name: "Titan Chair Medium Back White", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/titan_chair_mb_white.png"], featured: false, specifications: { backType: "Medium Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1025, name: "Kbc Chair Revolving Medium Back", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/kbc_chair_revolving_mb.png"], featured: false, specifications: { backType: "Medium Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1026, name: "Apex Chair", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/a8619.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1027, name: "Star Stool High Back Green", category: "Seating", subcategory: "Bar Stool", images: ["/images/chairs/star_stool_hb_green.png"], featured: false, specifications: { backType: "High Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1028, name: "Zara Pu Puffy", category: "Seating", subcategory: "Lounge Chair", images: ["/images/chairs/zara_pu_puffy_arkvirgo_29_arkvirgo_37.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1029, name: "Jazz High Back Grey", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/jazz_hb_grey.png"], featured: false, specifications: { backType: "High Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1030, name: "Wave Visitor Chair", category: "Seating", subcategory: "Visitor Chair", images: ["/images/chairs/wave_visitor_chair.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1031, name: "Titan Chair Medium Back Grey Chrome Handle", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/titan_chair_mb_grey_chrome_handle.png"], featured: false, specifications: { backType: "Medium Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1032, name: "C Cut String Chair", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/c_cut_string_chair.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1033, name: "Crown Premium High Back Black", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/crown_premium_hb_black.png"], featured: false, specifications: { backType: "High Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1034, name: "Pioneer High Back Chair", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/py-12_hb_chair.png"], featured: false, specifications: { backType: "High Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1035, name: "Sierra Chair", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/6a81_imported_chair.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1036, name: "Atlas Chair", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/a828_imported_chair.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1037, name: "Seltos Medium Back Black", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/seltos_mb_black.png"], featured: false, specifications: { backType: "Medium Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1038, name: "Cherry Chair Medium Back Black", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/cherry_chair_mb_black.png"], featured: false, specifications: { backType: "Medium Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1039, name: "C Cut Dining Chair", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/c_cut_dining_chair_arkvergo_23.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1040, name: "Fronx Chair High Back", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/fronx_chair_hb.png"], featured: false, specifications: { backType: "High Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1041, name: "Golden Chair", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/golden_chair.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1042, name: "Chunat Chair High Back", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/chunat_chair_hb.png"], featured: false, specifications: { backType: "High Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1043, name: "Noble Chair Medium Back", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/noble_chair_mb.png"], featured: false, specifications: { backType: "Medium Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1044, name: "Button Puffy Revolving", category: "Seating", subcategory: "Lounge Chair", images: ["/images/chairs/button_puffy_revolving.jpg"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1045, name: "Tack Chair High Back", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/tack_chair_hb.png"], featured: false, specifications: { backType: "High Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1046, name: "Button Puffy Revolving Brown", category: "Seating", subcategory: "Lounge Chair", images: ["/images/chairs/button_puffy_revolving_brown.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1047, name: "Rattan Chair Green", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/rattan_chair_green_cs-1240.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1048, name: "Net Revolving High Back", category: "Seating", subcategory: "Mesh Office Chair", images: ["/images/chairs/net_revolving_hb_imported.png"], featured: false, specifications: { backType: "High Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1049, name: "Wing Chair Medium Back", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/wing_chair_mb.png"], featured: false, specifications: { backType: "Medium Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1050, name: "Swan Pu Puffy", category: "Seating", subcategory: "Lounge Chair", images: ["/images/chairs/swan_pu_puffy.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1051, name: "Nexus Chair", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/a2317_chair.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1052, name: "Infinity Net Visitor Chair Grey", category: "Seating", subcategory: "Visitor Chair", images: ["/images/chairs/8008_net_visitor_chair_grey.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1053, name: "Zenith Chair", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/z020_chair.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1054, name: "Net Border Net Chair High Back", category: "Seating", subcategory: "Mesh Office Chair", images: ["/images/chairs/net_border_net_chair_hb.png"], featured: false, specifications: { backType: "High Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1055, name: "Cherry Chair Medium Back Grey", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/cherry_chair_mb_grey.png"], featured: false, specifications: { backType: "Medium Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1056, name: "Beta Chair Black Medium Back", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/beta_chair_black_mb.png"], featured: false, specifications: { backType: "Medium Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1057, name: "Focus Chair", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/fsa28_chair.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1058, name: "Half Rib Chair Medium Back", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/half_rib_chair_mb.png"], featured: false, specifications: { backType: "Medium Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1059, name: "Star Stool High Back Beige", category: "Seating", subcategory: "Bar Stool", images: ["/images/chairs/star_stool_hb_beige.png"], featured: false, specifications: { backType: "High Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1060, name: "Net Border Chair Medium Back Grey", category: "Seating", subcategory: "Mesh Office Chair", images: ["/images/chairs/net_border_chair_mb_grey.png"], featured: false, specifications: { backType: "Medium Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1061, name: "Oasis High Back Chair", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/121a_hb_chair_imported.png"], featured: false, specifications: { backType: "High Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1062, name: "Button Stool Fixed", category: "Seating", subcategory: "Bar Stool", images: ["/images/chairs/button_stool_fixed.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1063, name: "Egg Chair Black Medium Back", category: "Seating", subcategory: "Lounge Chair", images: ["/images/chairs/egg_chair_black_mb.png"], featured: false, specifications: { backType: "Medium Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1064, name: "Gardenia Puffy", category: "Seating", subcategory: "Lounge Chair", images: ["/images/chairs/gardenia_puffy_arkvirgo_31_32.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1065, name: "Lucano Chair High Back", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/lucano_chair_hb.png"], featured: false, specifications: { backType: "High Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1066, name: "Legender Puffy Chair", category: "Seating", subcategory: "Lounge Chair", images: ["/images/chairs/legender_puffy_chair.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1067, name: "C Cut Dining Chair", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/c_cut_dining_chair_arkvergo_12.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1068, name: "Vista Chair", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/6b81_imported_chair.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1069, name: "C Cut Dining Chair", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/c_cut_dining_chair_arkvergo_10.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1070, name: "Peacock Quilting Chair", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/peacock_quilting_chair.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1071, name: "Egg Chair Grey Medium Back", category: "Seating", subcategory: "Lounge Chair", images: ["/images/chairs/egg_chair_grey_mb.png"], featured: false, specifications: { backType: "Medium Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1072, name: "Optima Net Chair", category: "Seating", subcategory: "Mesh Office Chair", images: ["/images/chairs/optima_net_chair.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1073, name: "Sofa Chair", category: "Seating", subcategory: "Lounge Chair", images: ["/images/chairs/sofa_chair.jpg"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1074, name: "Infinity Net Visitor Chair Black", category: "Seating", subcategory: "Visitor Chair", images: ["/images/chairs/8008_net_visitor_chair_black.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1075, name: "Button Stool Fixed Green", category: "Seating", subcategory: "Bar Stool", images: ["/images/chairs/button_stool_fixed_green.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1076, name: "Butter Fly Chair High Back Black", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/butter_fly_chair_hb_black.png"], featured: false, specifications: { backType: "High Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1077, name: "Kbc Visitor Chair Medium Back", category: "Seating", subcategory: "Visitor Chair", images: ["/images/chairs/kbc_visitor_chair_mb.png"], featured: false, specifications: { backType: "Medium Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1078, name: "Round Stool Fixed Green", category: "Seating", subcategory: "Bar Stool", images: ["/images/chairs/round_stool_fixed_green.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1079, name: "Vanguard Chair", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/6646a_chair.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1080, name: "Bravo Chair Black", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/bravo_chair_black.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1081, name: "Beta Pro Medium Back Grey", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/beta_pro_mb_grey.png"], featured: false, specifications: { backType: "Medium Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1082, name: "Horizon Chair", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/179a_imported_chair.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1083, name: "Quantum Chair", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/5002_imported_chair.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1084, name: "Wing Chair High Back", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/wing_chair_hb.png"], featured: false, specifications: { backType: "High Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1085, name: "Jazz Medium Back Grey", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/jazz_mb_grey.png"], featured: false, specifications: { backType: "Medium Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1086, name: "Elegenza Chair Nimbus", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/elegenza_chair_nimbus_2.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1087, name: "Jazz High Back Black", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/jazz_hb_black.png"], featured: false, specifications: { backType: "High Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1088, name: "Cashewnut Chair", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/cashewnut_chair.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1089, name: "Onyx Chair", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/666_imported_chair.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1090, name: "Aero Chair", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/a-888_imported_chair.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1091, name: "Bucket Diamond Chair", category: "Seating", subcategory: "Lounge Chair", images: ["/images/chairs/bucket_diamond_chair.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1092, name: "Polyfill Chair High Back Tan", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/polyfill_chair_hb_tan.png"], featured: false, specifications: { backType: "High Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1093, name: "Nova Plus Chair", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/6127b_chair.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1094, name: "Aero Plus Chair", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/b-888_imported_chair.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1095, name: "Jazz Medium Back Black", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/jazz_mb_black.png"], featured: false, specifications: { backType: "Medium Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1096, name: "Butter Fly Chair Medium Back Grey", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/butter_fly_chair_mb_grey.png"], featured: false, specifications: { backType: "Medium Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1097, name: "Atlas Plus Chair", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/b828_imported_chair.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1098, name: "Seltos Chair Medium Back", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/seltos_chair_mb.png"], featured: false, specifications: { backType: "Medium Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1099, name: "Equinox Chair", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/b825_imported_chair.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1100, name: "Nitin Bar Stool", category: "Seating", subcategory: "Bar Stool", images: ["/images/chairs/nitin_bar_stool.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1101, name: "Butter Fly Chair Medium Back Black", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/butter_fly_chair_mb_black.png"], featured: false, specifications: { backType: "Medium Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1102, name: "Bubble Chair", category: "Seating", subcategory: "Visitor Chair", images: ["/images/chairs/bubble_chair.png"], featured: false, specifications: { backType: "", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1103, name: "Fronx Chair Medium Back", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/fronx_chair_mb.jpg"], featured: false, specifications: { backType: "Medium Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1104, name: "Zeta Chair High Back", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/zeta_chair_hb.png"], featured: false, specifications: { backType: "High Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  { id: 1105, name: "Noble Chair High Back", category: "Seating", subcategory: "Office Chair", images: ["/images/chairs/noble_chair_hb.png"], featured: false, specifications: { backType: "High Back", upholstery: "", armrest: "", material: "", base: "", color: "" }, tags: [] },
  // ==========================================
  // --- TABLE (MOCK DATA) ---
  // ==========================================
  {
    id: 2001,
    name: "9824 Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/9824_executive_table.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2002,
    name: "A006 Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/a006_table_2.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2003,
    name: "A-006",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/a_006.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2004,
    name: "Accord Table Set",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/accord_table_set.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2005,
    name: "Ace Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/ace_table_2.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2006,
    name: "AKY-005",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/aky_005.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2007,
    name: "Alpha Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/alpha_executive_table.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2008,
    name: "Amaze Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/amaze_executive_table.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2009,
    name: "Amazon Partner Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/amazon_partner_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2010,
    name: "Apex Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/apex_executive_table.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2011,
    name: "Architect Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/architect_table_2.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2012,
    name: "Austin Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/austin_executive_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2013,
    name: "Austin Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/austin_executive_table_2.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2014,
    name: "Baron Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/baron_executive_table.jpg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2015,
    name: "Casper Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/casper_executive_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2016,
    name: "CBD-316 Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/cbd_316_executive_table.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2017,
    name: "Cliff Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/cliff_executive_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2018,
    name: "Cobra Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/cobra_executive_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2019,
    name: "Converge Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/converge_executive_table_2.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2020,
    name: "Crest Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/crest_executive_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2021,
    name: "Cross Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/cross_table_2.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2022,
    name: "Cube Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/cube_executive_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2023,
    name: "Domino Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/domino_executive_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2024,
    name: "Edge Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/edge_executive_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2025,
    name: "Elite Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/elite_executive_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2026,
    name: "Emperor Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/emperor_executive_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2027,
    name: "Emperor Executive Table 2",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/emperor_executive_table_2.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2028,
    name: "Fab Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/fab_table_2.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2029,
    name: "Flamingo Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/flamingo_executive_table.jpg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2030,
    name: "Flamingo Lorraine Walnut Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/flamingo_lorraine_walnut_table.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2031,
    name: "Flash Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/flash_executive_table.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2032,
    name: "Focus Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/focus_executive_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2033,
    name: "Global Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/global_executive_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2034,
    name: "Height Adjusting Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/height_adjusting_table_2.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2035,
    name: "Lexus Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/lexus_executive_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2036,
    name: "Magnum Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/magnum_executive_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2037,
    name: "Matrix Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/matrix_executive_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2038,
    name: "Metro Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/metro_table_2.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2039,
    name: "Milano Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/milano_executive_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2040,
    name: "Mint Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/mint_executive_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2041,
    name: "Monarch Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/monarch_executive_table_2.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2042,
    name: "Nautica Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/nautica_executive_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2043,
    name: "Newton Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/newton_executive_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2044,
    name: "Noir Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/noir_executive_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2045,
    name: "Open Plan Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/open_plan_table.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2046,
    name: "Open Plan Table 1",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/open_plan_table_1_2.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2047,
    name: "Outline Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/outline_executive_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2048,
    name: "Outline Plus Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/outline_plus_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2049,
    name: "Partner Table Set",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/partner_table_set.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2050,
    name: "Platinum Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/platinum_executive_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2051,
    name: "Prestige Partner Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/prestige_partner_table_2.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2052,
    name: "Pyramid Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/pyramid_executive_table.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2053,
    name: "Quartz Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/quartz_executive_table.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2054,
    name: "Rainbow Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/rainbow_executive_table.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2055,
    name: "Reboot Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/reboot_table.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2056,
    name: "Regal Office Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/regal_office_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2057,
    name: "Rolex Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/rolex_executive_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2058,
    name: "Solitaire Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/solitaire_executive_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2059,
    name: "Star Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/star_executive_table.jpg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2060,
    name: "Star Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/star_table.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2061,
    name: "Summit Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/summit_executive_table_2.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2062,
    name: "T-830 4 SR LHS 10599 22107",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/t_830_4_sr_lhs_10599_22107.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2063,
    name: "Titan Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/titan_executive_table.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2064,
    name: "Tuff Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/tuff_executive_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2065,
    name: "Uber Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/uber_executive_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2066,
    name: "Unicorn Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/unicorn_executive_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2067,
    name: "Unity Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/unity_table_2.jpg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2068,
    name: "Vision Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/vision_executive_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2069,
    name: "Waterfall Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/waterfall_table_2.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2070,
    name: "Windsor Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/windsor_executive_table.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2071,
    name: "Z Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/z_table_2.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2072,
    name: "Zapp Executive Table",
    category: "Table",
    subcategory: "Executive Table",
    images: ["/images/tables/zapp_executive_table.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2073,
    name: "Action Reception Table",
    category: "Table",
    subcategory: "Reception Table",
    images: ["/images/tables/action_reception_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2074,
    name: "Aura Reception Table",
    category: "Table",
    subcategory: "Reception Table",
    images: ["/images/tables/aura_reception_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2075,
    name: "Blazer Reception Table",
    category: "Table",
    subcategory: "Reception Table",
    images: ["/images/tables/blazer_reception_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2076,
    name: "City Reception Table",
    category: "Table",
    subcategory: "Reception Table",
    images: ["/images/tables/city_reception_table.jpg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2077,
    name: "Compact Reception Table",
    category: "Table",
    subcategory: "Reception Table",
    images: ["/images/tables/compact_reception_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2078,
    name: "Cool Reception Table",
    category: "Table",
    subcategory: "Reception Table",
    images: ["/images/tables/cool_reception_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2079,
    name: "Cyber Reception Table",
    category: "Table",
    subcategory: "Reception Table",
    images: ["/images/tables/cyber_reception_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2080,
    name: "Element Reception Table",
    category: "Table",
    subcategory: "Reception Table",
    images: ["/images/tables/element_reception_table_2.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2081,
    name: "Elva Reception Table",
    category: "Table",
    subcategory: "Reception Table",
    images: ["/images/tables/elva_reception_table.jpg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2082,
    name: "Fiesta Reception Table",
    category: "Table",
    subcategory: "Reception Table",
    images: ["/images/tables/fiesta_reception_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2083,
    name: "Image Reception Table",
    category: "Table",
    subcategory: "Reception Table",
    images: ["/images/tables/image_reception_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2084,
    name: "Jazz Reception Table",
    category: "Table",
    subcategory: "Reception Table",
    images: ["/images/tables/jazz_reception_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2085,
    name: "Leo Double Reception Table",
    category: "Table",
    subcategory: "Reception Table",
    images: ["/images/tables/leo_double_reception_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2086,
    name: "Leo Reception Table",
    category: "Table",
    subcategory: "Reception Table",
    images: ["/images/tables/leo_reception_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2087,
    name: "Louvers Reception Table",
    category: "Table",
    subcategory: "Reception Table",
    images: ["/images/tables/louvers_reception_table.jpg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2088,
    name: "Majestic Reception Table",
    category: "Table",
    subcategory: "Reception Table",
    images: ["/images/tables/majestic_reception_table.jpg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2089,
    name: "Pixel Diagonal Reception Table",
    category: "Table",
    subcategory: "Reception Table",
    images: ["/images/tables/pixel_diagonal_reception_table_2.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2090,
    name: "Pixel Reception Table",
    category: "Table",
    subcategory: "Reception Table",
    images: ["/images/tables/pixel_reception_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2091,
    name: "Sway Reception Table",
    category: "Table",
    subcategory: "Reception Table",
    images: ["/images/tables/sway_reception_table.webp"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2092,
    name: "Urban Linear Reception Table",
    category: "Table",
    subcategory: "Reception Table",
    images: ["/images/tables/urban_linear_reception_table.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2093,
    name: "Venus Reception Table",
    category: "Table",
    subcategory: "Reception Table",
    images: ["/images/tables/venus_reception_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2094,
    name: "Vertex Reception Table",
    category: "Table",
    subcategory: "Reception Table",
    images: ["/images/tables/vertex_reception_table_2.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2095,
    name: "Zen Reception Table",
    category: "Table",
    subcategory: "Reception Table",
    images: ["/images/tables/zen_reception_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2096,
    name: "Zentra Reception Table",
    category: "Table",
    subcategory: "Reception Table",
    images: ["/images/tables/zentra_reception_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2097,
    name: "Harmony Centre Table",
    category: "Table",
    subcategory: "Center Table",
    images: ["/images/tables/918_1_1_harmony_centre_table.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2098,
    name: "Vertex Centre Table",
    category: "Table",
    subcategory: "Center Table",
    images: ["/images/tables/b718_1_1_vertex_centre_table.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2099,
    name: "Cello Centre Table",
    category: "Table",
    subcategory: "Center Table",
    images: ["/images/tables/cello_centre_table_1200x600.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2100,
    name: "Grace Centre Table",
    category: "Table",
    subcategory: "Center Table",
    images: ["/images/tables/grace_centre_table.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2101,
    name: "H Centre Table",
    category: "Table",
    subcategory: "Center Table",
    images: ["/images/tables/h_centre_table.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2102,
    name: "Phoenix Centre Table",
    category: "Table",
    subcategory: "Center Table",
    images: ["/images/tables/phoenix_centre_table.jpeg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2103,
    name: "V Centre Table",
    category: "Table",
    subcategory: "Center Table",
    images: ["/images/tables/v_centre_table_1103_hgl_1105.jpg"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },
  {
    id: 2104,
    name: "V Side Table",
    category: "Table",
    subcategory: "Center Table",
    images: ["/images/tables/v_side_table_2.png"],
    featured: false,
    specifications: { material: "", dimensions: "", color: "" },
    tags: []
  },

 // ==========================================
// --- CONFERENCE TABLES ---
// ==========================================
{
  id: 2105,
  name: "Austin Conference Table",
  category: "Table",
  subcategory: "Conference Table",
  images: ["/images/tables/austin_conference_table_2.jpg"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 2106,
  name: "Diamond Conference Table",
  category: "Table",
  subcategory: "Conference Table",
  images: ["/images/tables/diamond_conference_table.jpg"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 2107,
  name: "Drift Conference Table",
  category: "Table",
  subcategory: "Conference Table",
  images: ["/images/tables/drift_conference_table_2.png"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 2108,
  name: "Fab Conference Table",
  category: "Table",
  subcategory: "Conference Table",
  images: ["/images/tables/fab_conference_table_2.png"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 2109,
  name: "Flyp Conference Table",
  category: "Table",
  subcategory: "Conference Table",
  images: ["/images/tables/flyp_conference_table.png"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 2110,
  name: "Monarch Conference Table",
  category: "Table",
  subcategory: "Conference Table",
  images: ["/images/tables/monarch_conference_table.jpg"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},

 // ==========================================
// --- WORKSTATIONS ---
// ==========================================
{
  id: 3001,
  name: "Drift Work Station",
  category: "Workstations",
  subcategory: "Workstation",
  images: ["/images/workstations/drift_work_station_2.png"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 3002,
  name: "Open Loop Workstation",
  category: "Workstations",
  subcategory: "Workstation",
  images: ["/images/workstations/open_loop_workstation_2.png"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 3003,
  name: "Planter Workstation Face To Face",
  category: "Workstations",
  subcategory: "Workstation",
  images: ["/images/workstations/planter_workstation_face_to_face_2.png"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 3004,
  name: "Round Workstation",
  category: "Workstations",
  subcategory: "Workstation",
  images: ["/images/workstations/round_workstation.jpg"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 3005,
  name: "Tasko Workstation",
  category: "Workstations",
  subcategory: "Workstation",
  images: ["/images/workstations/tasko_workstation_2.png"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 3006,
  name: "Workstation 45Mm 001",
  category: "Workstations",
  subcategory: "Workstation",
  images: ["/images/workstations/workstation_45mm_001_2.png"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},

// ==========================================
// --- STORAGE ---
// ==========================================
{
  id: 4001,
  name: "Back Storage",
  category: "Storage",
  subcategory: "",
  images: ["/images/storage/back_storage_2004_2.png"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 4002,
  name: "Back Storage",
  category: "Storage",
  subcategory: "",
  images: ["/images/storage/back_storage_2_panel.png"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 4003,
  name: "Back Storage Reception",
  category: "Storage",
  subcategory: "",
  images: ["/images/storage/back_storage_reception.jpg"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 4004,
  name: "Back Storage Reception",
  category: "Storage",
  subcategory: "",
  images: ["/images/storage/back_storage_reception_black_22107.png"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 4005,
  name: "Fix Pedestal",
  category: "Storage",
  subcategory: "",
  images: ["/images/storage/fix_pedestal_3002.png"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 4006,
  name: "Medium Height Storage",
  category: "Storage",
  subcategory: "",
  images: ["/images/storage/medium_height_storage_irish_cream_2.png"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 4007,
  name: "Mobile Pedestal",
  category: "Storage",
  subcategory: "",
  images: ["/images/storage/mobile_pedestal_2.png"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 4008,
  name: "Mobile Pedestal (2 Drawer)",
  category: "Storage",
  subcategory: "",
  images: ["/images/storage/mobile_pedestal_2_drawer.png"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 4009,
  name: "Mobile Pedestal Lorraine Walnut",
  category: "Storage",
  subcategory: "",
  images: ["/images/storage/mobile_pedestal_lorraine_walnut_3007.png"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 4010,
  name: "Open Storage Veneer",
  category: "Storage",
  subcategory: "",
  images: ["/images/storage/open_storage_veneer.png"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 4011,
  name: "Overhead Storage",
  category: "Storage",
  subcategory: "",
  images: ["/images/storage/overhead_storage.jpeg"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 4012,
  name: "Planter Storage",
  category: "Storage",
  subcategory: "",
  images: ["/images/storage/planter_storage_2.png"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 4013,
  name: "Printer Storage",
  category: "Storage",
  subcategory: "",
  images: ["/images/storage/printer_storage_2.png"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 4014,
  name: "Stellar Book Shelf",
  category: "Storage",
  subcategory: "",
  images: ["/images/storage/stellar_book_shelf_900x400x1850.png"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 4015,
  name: "TV Cabinet",
  category: "Storage",
  subcategory: "",
  images: ["/images/storage/tv_cabinet_803.png"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},




  // ==========================================
// --- SOFA / LOUNGER ---
// ==========================================
{
  id: 5001,
  name: "Bentley Sofa (2 Seater)",
  category: "Sofa / Lounger",
  subcategory: "Sofa",
  images: ["/images/sofas/bentley_sofa_2_seater.jpeg"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 5002,
  name: "Box Sofa (2 Seater)",
  category: "Sofa / Lounger",
  subcategory: "Sofa",
  images: ["/images/sofas/box_sofa_2_seater.jpg"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 5003,
  name: "Box Sofa (3 Seater)",
  category: "Sofa / Lounger",
  subcategory: "Sofa",
  images: ["/images/sofas/box_sofa_3_seater.jpg"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 5004,
  name: "Chesterfield Sofa (3 Seater)",
  category: "Sofa / Lounger",
  subcategory: "Sofa",
  images: ["/images/sofas/chesterfield_sofa_3_seater.png"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 5005,
  name: "Compact Sofa",
  category: "Sofa / Lounger",
  subcategory: "Sofa",
  images: ["/images/sofas/compact_sofa.jpg"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 5006,
  name: "Emerald Sofa (3 Seater)",
  category: "Sofa / Lounger",
  subcategory: "Sofa",
  images: ["/images/sofas/emerald_sofa_3_seater.jpg"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 5007,
  name: "Flower Sofa (2 Seater)",
  category: "Sofa / Lounger",
  subcategory: "Sofa",
  images: ["/images/sofas/flower_sofa_2_seater.png"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 5008,
  name: "Flower Sofa (3 Seater)",
  category: "Sofa / Lounger",
  subcategory: "Sofa",
  images: ["/images/sofas/flower_sofa_3_seater.png"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 5009,
  name: "Godrej Sofa (2 Seater)",
  category: "Sofa / Lounger",
  subcategory: "Sofa",
  images: ["/images/sofas/godrej_sofa_2_seater.jpg"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 5010,
  name: "Godrej Sofa (3 Seater)",
  category: "Sofa / Lounger",
  subcategory: "Sofa",
  images: ["/images/sofas/godrej_sofa_3_seater.jpg"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 5011,
  name: "Metro Sofa (2 Seater)",
  category: "Sofa / Lounger",
  subcategory: "Sofa",
  images: ["/images/sofas/metro_sofa_2_seater.png"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 5012,
  name: "Metro Sofa Cushioned (3 Seater)",
  category: "Sofa / Lounger",
  subcategory: "Sofa",
  images: ["/images/sofas/metro_sofa_3_seater_cushioned.png"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 5013,
  name: "Rio Sofa (3 Seater)",
  category: "Sofa / Lounger",
  subcategory: "Sofa",
  images: ["/images/sofas/rio_sofa_3_seater.jpg"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 5014,
  name: "S Sofa (2 Seater)",
  category: "Sofa / Lounger",
  subcategory: "Sofa",
  images: ["/images/sofas/s_sofa_2_seater.png"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 5015,
  name: "Sumo Sofa (3 Seater)",
  category: "Sofa / Lounger",
  subcategory: "Sofa",
  images: ["/images/sofas/sumo_sofa_3_seater.jpg"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 5016,
  name: "Unicorn Sofa (3 Seater)",
  category: "Sofa / Lounger",
  subcategory: "Sofa",
  images: ["/images/sofas/unicorn_sofa_3_seater.jpg"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},
{
  id: 5017,
  name: "Vegas Sofa (2 Seater)",
  category: "Sofa / Lounger",
  subcategory: "Sofa",
  images: ["/images/sofas/vegas_sofa_2_seater.png"],
  featured: false,
  specifications: { material: "", dimensions: "", color: "" },
  tags: []
},

];



export const galleryProjects = [
  { id: 1, title: "Modern Tech Hub", location: "New Delhi", image: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1200&q=80", description: "Complete office setup for AARTEMA's premium clients." }
];

export const testimonials = [
  { id: 1, name: "Vikas Mangla", position: "Proprietor, AARTEMA", content: "Our goal is to redefine how people work, one desk at a time.", rating: 5 }
];
